import React from 'react';
import Avatar from './Avatar';
import { Link } from 'react-router-dom';
import { USER_PROFILE } from '../constants/routes';
import { VerifiedIcon } from './Icons';
import LastActiveBadge from './LastActiveBadge';
import PaymentModalContent from './generic-components/post/PaymentModalContent';

//  PROPS
// children - Anything instide <FollowBenefits> </FollowBenefits>
// user - Object
// hideBenefitsContent - Boolean :: default false :: hidden content for benefits
// hideCoverImage - Boolean :: default false :: hidden user.cover image 
const FollowBenefits = ({ children, user, hideBenefitsContent = false, hideCoverImage = false }) => {

  return !user ?
    <></> :
    <div className={'profile-header-content-container'}>
      <div
        className="profile-header d-flex flex-column justify-content-between profile-header-cover"
        style={{
          backgroundImage:  user.cover && `url('${user.cover}')`,
          height: 82,
          backgroundColor: '#8a8d92',
        }}
      >
      </div>

      <div className="d-flex align-items-start flex-column" style={{ marginTop: '0px' }}>
        <div className={'tip-avatar-wrapper d-flex'}>
          <Avatar  style={{ marginTop: '-27px' }} className="cursor-pointer" user={user && user.name} size={72} image={user && user.avatar} />

          <Link
            className="user-credentials-wrapper text-left mt-1 ml-1"
            to={USER_PROFILE.replace(':userId?', user.id).replace(':name?', !!user.nickname ? user.nickname : '')}
          >
            <div className={'user-container d-flex align-items-center'}>
              <p className=" font-weight-bold" style={{ color: '#e7eaf3' }}>{user.name}</p>
            
              
              {user.verification_status === "verified" && <VerifiedIcon  height="1rem" width="1rem" className={`fill-white verivication-follow-benefits`} />}
        
            </div>
            {!!user.nickname && <p className={'user-nikname'} style={{ color: '#8B95B1' }}>@{user.nickname}</p>}
        
            {/* {!!user.profession && <p className={'text-dark-gray font-size-12'}>{user.profession}</p>} */}
          </Link>
        </div>

        {!hideBenefitsContent && <PaymentModalContent user={user} />}

      </div>
    </div>
};

export default FollowBenefits;
